import React from 'react';

import { UserDirectoryPage } from './UserDirectoryPage';

export const AccountActivation: React.FC = () => (
  <UserDirectoryPage
    title="Account Activation Directory"
    actions={[
      {
        when: (status) => status === 'suspended',
        actionType: 'unsuspend',
        label: 'Unsuspend User Account',
        successMessage: (name) => `User "${name}" was successfully unsuspended!`,
      },
      {
        when: (status) => status === 'locked_out',
        actionType: 'unlock',
        label: 'Unlock User Account',
        successMessage: (name) => `User "${name}" was successfully unlocked!`,
      },
      {
        when: (status) => status === 'provisioned',
        actionType: 'activate',
        label: 'Send User Activation Email',
        successMessage: (name) => `User "${name}" was successfully sent activation email!`,
      },
      {
        when: (status) => status === 'password_expired',
        actionType: 'reset-password',
        label: 'Send password reset email',
        successMessage: (name) => `User "${name}" was successfully sent password reset email!`,
      },
    ]}
  />
);

export default AccountActivation;
